import React from 'react';

// nest component
const Nest = ({ i, providers, children }) => {
  if (i < providers.length) {
    const Provider = providers[i].comp || providers[i];

    return (
      <Provider {...providers[i].props}>
        <Nest providers={providers} i={i + 1}>
          {children}
        </Nest>
      </Provider>
    );
  } else {
    return children;
  }
};

// wrapper
const MegaWrapper = ({ providers, children }) => (
  <Nest providers={providers} i={0}>
    {children}
  </Nest>
);

export default MegaWrapper;
